<template>
  <div class="homePage">
    <div class="big-6">
      <div class="title">{{ $t("help.help.title1") }},</div>
      <div>{{ $t("help.help.title2") }}?</div>
    </div>
    <div class="search-box">
      <el-autocomplete
        popper-class="form-control"
        :fetch-suggestions="querySearch"
        v-model="queryState"
        :placeholder="$t('help.help.searchPlaceholder')"
      >
        <div class="search" slot="suffix">
          <img src="@/assets/image/module/search2.png" />
        </div>
        <template slot-scope="{ item }">
          <div class="name" @click="queryActive(item.active)">
            {{ item.name }}
          </div>
        </template>
      </el-autocomplete>
    </div>

    <div class="content-box">
      <div class="line-box">
        <div class="line"></div>
        <div class="text">{{ $t("help.help.title3") }}</div>
        <div class="line"></div>
      </div>

      <div class="nav-content">
        <div class="nav-list">
          <div
            class="nav-list-item"
            v-for="(item, index) in list"
            :key="item.name"
          >
            <div class="name-1">{{ item.name }}</div>
            <div
              v-for="(cItem, cIndex) in item.children"
              class="children"
              :key="cItem.title"
              @click="changeActive(cItem.active, cItem)"
            >
              <div :class="['name-2', { active: active === cItem.active }]">
                <span></span> {{ cItem.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="nav-box">
          <!-- <div
            v-for="(item, index) in $t(`help.help.content${type}`)"
            :key="index"
          >
            <div class="title">{{ item.title1 }}</div>
            <div class="p-box" v-if="!item.type">
              <p v-for="(cItem, cIndex) in item.pList" :key="cIndex">
                <span v-if="cItem.nameFa">{{ cItem.nameFa }} <br /></span>
                {{ cItem.name }}
              </p>
            </div>
            <div class="p-box" v-if="item.type === 1">
              <p
                v-for="(cItem, cIndex) in item.pList"
                v-html="cItem.name"
                :key="cIndex"
              ></p>
            </div>
          </div> -->

          <div v-html="content"></div>
        </div>
      </div>
    </div>

    <!-- <div class="search-m">
      <el-autocomplete
        popper-class="form-control2"
        :fetch-suggestions="querySearch"
        v-model="queryState2"
        placeholder="请输入搜索内容"
      >
        <template slot-scope="{ item }">
          <div class="name" @click="queryActive(item.active)">
            {{ item.name }}
          </div>
        </template>
      </el-autocomplete>
      <div class="search" slot="suffix">
        <img src="@/assets/image/module/search.png" />
      </div>
    </div> -->

    <div class="m-boxs">
      <div
        :class="['m-box', { active2: active === item.active }]"
        v-for="(item, index) in list2"
        :key="index"
      >
        <div class="name-box" @click="changeActive(item.active, item)">
          <div>{{ item.title }}</div>
          <img src="@/assets/image/module/arrow-right2.png" />
        </div>
        <div class="title-box" v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { getQuestionTypes, getQuestions } from "@/api/user";
export default {
  data() {
    return {
      list: [],
      list2: [],
      active: 1,
      type: 1,
      content: null,
      queryState: null,
      queryState2: null,
    };
  },

  methods: {
    changeActive(active, data) {
      this.active = active;

      this.content = data.content;
      console.log("this.active", this.active);
    },
    queryActive(active) {
      this.active = active;
      const index = this.list2.findIndex((item) => {
        return item.active === active;
      });
      this.content = this.list2[index].content;
    },
    //问题分类
    async getQuestionTypes() {
      await getQuestionTypes().then(async (res) => {
        if (res.code === 200) {
          this.list = res.data.map((item) => {
            // 返回一个新对象，展开原对象属性，并覆盖 isActive 为 false
            return { ...item, children: [] };
          });

          for (let i = 0; i < this.list.length; i++) {
            await getQuestions({ categoryId: this.list[i].id }).then((res) => {
              if (res.code === 200) {
                let lastIndex = 1;
                if (i !== 0) {
                  lastIndex = this.list[i - 1].children.length + 1;
                }
                const list = res.data.list.map((item, cIndex) => {
                  // 返回一个新对象，展开原对象属性，并覆盖 isActive 为 false
                  return { ...item, active: cIndex + lastIndex };
                });
                this.list[i].children = this.list[i].children.concat(list);
                this.list2 = this.list2.concat(list);
                console.log(1123, this.list);
              }
            });
          }
        }
      });
    },

    searchNavigation(data, keyword) {
      if (!keyword) {
        return [];
      }
      const result = [];
      function search(items) {
        for (const item of items) {
          if (item.title && item.title.includes(keyword)) {
            // 如果有path属性，则添加到结果中
            if (item.title) {
              result.push({
                name: item.title,
                active: item.active,
              });
            }
          }

          // 如果有子项，递归搜索
          if (item.children && Array.isArray(item.children)) {
            search(item.children);
          }
        }
      }

      search(data);
      return result;
    },

    querySearch(queryString, cb) {
      var results = this.searchNavigation(this.list2, queryString) || [];
      cb(results);
    },
  },
  async created() {
    await this.getQuestionTypes();
    if (this.$route.query.id == 2) {
      this.active = this.list[0].children.length +1;
      console.log('this.active',this.active)
      this.content = this.list[1].children[0].content;
    } else {
      this.content = this.list[0].children[0].content;
    }
  },
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.homePage {
  background-color: #fff;
  padding-top: 48px;
  .big-6 {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 935px;
    height: 185px;
    background-image: url("../assets/image/module/bg6.png");
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    font-size: 36px;
    font-weight: bolder;
    color: #474f66;
    text-align: center;
    .title {
      margin-top: 36px;
    }
  }
  .search-box {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 733px;
    height: 60px;
    background: #f4f5f8;
    position: relative;
    border-radius: 30px;
    .search {
      position: absolute;
      width: 113px;
      height: 60px;
      background: #8948ff;
      border-radius: 0px 40px 40px 0px;
      right: -4px;
      top: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      // cursor: pointer;
      img {
        width: 30px;
        height: 30px;
      }
    }
  }
  .content-box {
    width: 100%;
    box-sizing: border-box;
    padding: 0 140px;
    margin-top: 60px;
    .line-box {
      display: flex;
      align-items: center;
      width: 100%;
      .text {
        width: 200px;
        text-align: center;
        color: #999999;
        font-size: 16px;
      }
      .line {
        width: calc((100% - 200px) / 2);
        height: 1px;
        background-color: #f4f4f4;
      }
    }
    .nav-content {
      display: flex;
      margin-top: 63px;
      .nav-list {
        .nav-list-item {
          width: 180px;
          line-height: 42px;
          .name-1 {
            width: 100%;
            height: 42px;
            color: #474f66;
            font-size: 16px;
            font-weight: bolder;
            padding-left: 33px;
            box-sizing: border-box;
          }
          .name-2 {
            width: 100%;
            height: 42px;
            color: #474f66;
            font-size: 14px;
            cursor: pointer;
            position: relative;
            padding-left: 33px;
            box-sizing: border-box;
          }
          .active {
            color: #8948ff;
            background-color: #f9f5ff;
            span {
              position: absolute;
              height: 23px;
              border: 1px solid #8948ff;
              top: 9px;
              left: 0;
            }
          }
        }
      }
      .nav-box {
        width: 100%;
        padding-left: 65px;
        box-sizing: border-box;
        .title {
          font-size: 16px;
          color: #474f66;
          font-weight: bolder;
        }
        .p-box {
          margin-top: 18px;
          margin-bottom: 25px;
          font-size: 14px;
          color: #474f66;
          line-height: 24px;
          span {
            color: red;
          }
        }
      }
    }
  }
  .search-m {
    display: none;
    position: relative;
    width: 100%;
    height: 40px;
    background: #ffffff;
    border-radius: 17px 17px 17px 17px;
    margin-top: 15px;
    input {
      width: 100%;
      height: 34px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 17px 17px 17px 17px;
      border: none;
      outline: none;
      padding: 0 26px 0 50px;
      font-size: 14px;
    }
    .search {
      position: absolute;
      left: 8px;
      top: 8px;
      img {
        width: 24px;
        height: 24px;
      }
    }
  }
  .m-boxs {
    display: none;
    margin-bottom: 40px;
    .m-box {
      background-color: #fff;
      border-radius: 4px;
      margin-top: 10px;
      height: 38px;
      overflow: hidden;
      padding: 0 10px;
      box-sizing: border-box;
      .name-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 38px;
        color: #232323;
        font-size: 14px;
        font-weight: bolder;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .title-box {
        padding-top: 15px;
        padding-bottom: 7px;
        .title {
          color: #232323;
          font-size: 14px;
          font-weight: bolder;
          margin-bottom: 10px;
        }
        p {
          color: #232323;
          font-size: 14px;
          line-height: 24px;
        }
        .p-box {
          margin-top: 18px;
          margin-bottom: 25px;
          font-size: 14px;
          color: #474f66;
          line-height: 24px;
          span {
            color: red;
          }
        }
      }
    }
    .active2 {
      height: auto;
    }
  }
}
.search-box {
  .el-autocomplete {
    height: 60px;
    width: 100%;
    border-radius: 30px;
  }
}
.search-m {
  .el-autocomplete {
    height: 40px;
    width: 100%;
    border-radius: 20px;
  }
}
</style>
<style scoped>
.search-box > .el-autocomplete >>> .el-input__inner {
  height: 60px;
  border-radius: 30px !important;
  padding-right: 128px !important;
}
.search-m > .el-autocomplete >>> .el-input__inner {
  padding-left: 35px;
}
</style>
<style>
.form-control {
  width: 500px !important;
}
</style>
<style lang="scss" scoped>
@media only screen and (max-width: 1300px) {
  .homePage {
    .content-box {
      padding: 0 70px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .content-box {
      padding: 0 30px;
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    background-color: #f7f8fa;
    padding: 0 15px;
    .big-6 {
      display: none;
    }
    .search-box {
      display: none;
    }
    .content-box {
      display: none;
    }
    .search-m {
      display: block;
    }
    .m-boxs {
      display: block;
    }
  }
}
</style>